export default "__VITE_ASSET__BTw$eG3F__"